import React from "react";

const SubHeadline = ({ subHeadline, sectionSlug = "", subheadlineStyles = {}, ...rest }) => {
  let style = {};

  switch (sectionSlug) {
    case "friday":
      style = {
        ...subheadlineStyles,
        fontFamily: "var(--primary-font)",
        fontWeight: "var(--regular)",
      };
      break;
    case "your-money":
    case "best-buys":
    case "living-in-uae":
      style = { ...subheadlineStyles, fontFamily: "var(--secondary-font)", fontWeight: "var(--medium)" };
      break;
    case "parenting":
    case "videos":
      style = { ...subheadlineStyles, fontFamily: "var(--primary-font)", fontWeight: "var(--regular)" };
      break;
    default:
      style = subheadlineStyles;
  }
  return (
    <h3 {...rest} style={style}>
      {subHeadline}
    </h3>
  );
};

export default SubHeadline;
